
import {throttle} from "//www.dorelan.com/cdn/shop/t/3/assets/theme.js?v=121973350785694314881751472089";

// Header padding fix
const header_element = document.querySelector('.header__wrapper');

function stickyHeaderSize() {
  const shouldBeSticky = window.scrollY > 30;
  const isSticky = header_element.classList.contains('dor-header-sticky');
  
  if (isSticky !== shouldBeSticky) {
    header_element.classList.toggle('dor-header-sticky', shouldBeSticky);
  }
}

const checkScrollPosition = throttle(stickyHeaderSize);
document.addEventListener('scroll', checkScrollPosition, {passive: true});